import { Money } from "@/types";

export function formatMoney(
  money: Money,
  options: Intl.NumberFormatOptions = {},
) {
  const moneyFormatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: money.currency,
    maximumFractionDigits: 2,
    ...options,
  });

  if (money.currency === "BGN") {
    return `${moneyFormatter.format(Number(money.amount)).replace("BGN\u00A0", "")}\u00A0лв.`;
  } else {
    return moneyFormatter.format(Number(money.amount));
  }
}
